/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////
import { withTheme } from "@material-ui/core/styles";
import styled from "styled-components";

const StyledOverlay = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.palette.grey[300]};
  height: 100vh;
  width: 100vw;
  z-index: 100;
  opacity: 0.5;
`;

export default withTheme(StyledOverlay);
